import { default as EntitySelect } from 'browser/components/atomic-elements/atoms/select/entity-select'
import { default as EntityAssociationSelect } from 'browser/components/atomic-elements/atoms/select/entity-association-select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const EntitySelectField = LabelFieldFactory({ InputComponent: EntitySelect })
const EntityAssociationSelectField = LabelFieldFactory({ InputComponent: EntityAssociationSelect })
export {EntitySelectField, EntityAssociationSelectField}
